import React from 'react';
import ReactQuill from 'react-quill-new'
import 'quill/dist/quill.snow.css';

export default function AdvancedTextEditor({ value, onChange }) {
  return (
    <div style={{ 
      '--quill-font-size': '16px'
    }}>
      <ReactQuill 
        theme="snow"
        value={value}
        onChange={onChange}
        modules={{
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['blockquote', 'code-block'],
            ['clean']
          ]
        }}
        placeholder="Enter your message here..."
        style={{
          fontSize: '16px'
        }}
      />
      <style>{`
        .ql-editor {
          font-size: 18px; /* Larger display for better editing UX */
          line-height: 1.6;
          min-height: 200px;
          overflow-wrap: break-word; /* Break long words */
          word-wrap: break-word; /* Legacy support */
          hyphens: none; /* No hyphens - words just wrap to next line */
        }
        .ql-editor p,
        .ql-editor li {
          font-size: 18px; /* Larger display for better editing UX */
          overflow-wrap: break-word;
          word-wrap: break-word;
        }
        /* Override ReactQuill default heading sizes to match typography scale */
        .ql-editor h1 {
          font-size: var(--font-subtitle, 1.5rem); /* 24px - was 2em/32px */
        }
        .ql-editor h2 {
          font-size: var(--font-heading-sm, 1.25rem); /* 20px - was 1.5em/24px */
        }
        .ql-editor h3 {
          font-size: var(--font-lg, 1.125rem); /* 18px - was 1.17em/18.72px */
        }
        .ql-editor h4 {
          font-size: var(--font-base, 1rem); /* 16px - was 1em/16px */
        }
        .ql-editor h5 {
          font-size: var(--font-sm, 0.875rem); /* 14px - was 0.83em/13.28px */
        }
        .ql-editor h6 {
          font-size: var(--font-xs, 0.75rem); /* 12px - was 0.67em/10.72px */
        }
      `}</style>
    </div>
  );
}